import { lazyLoad } from 'utils/loadable';

export const WeeklyImagePage = lazyLoad(
  () => import('./index'),
  module => module.WeeklyImagePage,
);
